import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import orderApi from "api/order/OrderApi";
import ProcessingBar from "Util/Processingbar";
import { emptyCart } from "store/features/cartSlice";

const PayButton = ({ total, tip, paymentMethod, operator }) => {
  console.log({ total });
  const cart = useSelector((state) => state.cart.cart);
  const note = useSelector((state) => state.cart.note);

  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log({ cart });

  console.log({ note });

  const [isLoading, setIsLoading] = useState(false);

  const buildPayload = () => {
    const orderItems = cart.map((item) => ({
      title: item.title,
      qty: item.count,
      price: item.price,
      foodItem: item._id,
      operator: operator?._id,
      selectedOption: item.selectedOption, // ✅ ADD THIS

      operatorInfo: {
        name: operator.name,
        address: operator.address,
        photo: operator.photo,
      },
    }));

    const taxprice = 0; // ✅ define it

    return {
      user: user?._id,
      operator: operator?._id,
      customer_info: {
        email: user?.username,
        firstname: user?.displayName,
        phoneNumber: user?.phone || "",
        message: note || "", // ✅ correct
      },
      orderItems,
      payments: {
        paymentMethod: paymentMethod === "store" ? "cash" : "online",
      },
      subTotalPrice: total,
      tip: tip, // ⭐ ADD THIS
      taxprice,
      totalPrice: total + tip + taxprice,
    };
  };

  const handleCreateOrder = async () => {
    if (cart.length === 0) {
      toast.error("Your cart is empty");
      return;
    }

    setIsLoading(true);

    try {
      const payload = buildPayload();

      const { response, err } = await orderApi.createOrder(payload);

      if (err) throw new Error(err.message);

      toast.success(
        "Order created successfully! Email sent. Please check your inbox.",
      );

      dispatch(emptyCart()); // ⭐ EMPTY CART

      navigate(`/orderdetail/${response.data.order._id}`);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to create order");
    } finally {
      setIsLoading(false);
    }
  };

  const handleStripeCheckout = async () => {
    if (cart.length === 0) {
      toast.error("Your cart is empty");
      return;
    }

    setIsLoading(true);

    try {
      const payload = buildPayload();

      // ✅ STEP 1: Create order FIRST
      const { response: orderRes, err: orderErr } =
        await orderApi.createOrder(payload);

      if (orderErr) throw new Error(orderErr.message);

      const orderId = orderRes.data.order._id; // ✅ NOW YOU HAVE I

      const { response, err } = await orderApi.stripeCheckout({
        ...payload,
        id: orderId, // ✅ FIX HERE
      });

      dispatch(emptyCart()); // ⭐ EMPTY CART

      if (err) throw new Error(err.message);

      window.location.href = response.data.url;
    } catch (error) {
      toast.error(error.message || "Stripe checkout failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={
        paymentMethod === "online" ? handleStripeCheckout : handleCreateOrder
      }
      disabled={isLoading}
      className={`w-full py-4 rounded-xl font-semibold transition
        ${
          isLoading
            ? "bg-navy/70 cursor-not-allowed"
            : "bg-navy hover:opacity-90"
        }
      `}
    >
      <span className="text-yellowstar animate-neonFlicker">
        {isLoading ? (
          <ProcessingBar />
        ) : paymentMethod === "store" ? (
          `Place Order $${total.toFixed(2)}`
        ) : (
          `Pay now $${total.toFixed(2)}`
        )}
      </span>
    </button>
  );
};

export default PayButton;
